import { Injectable, Injector } from '@angular/core';
import { DataService } from './data.service';
import { ApiEndpoints } from '../../ApiEndpoints';

@Injectable({
  providedIn: 'root'
})
export class HouseViewsService extends DataService {

  constructor(injector: Injector) {
    super(injector);
  }

  // User house views
  getUserViews() {
    return this.getRequest(ApiEndpoints.myHouseViews);
  }

  getUserView(id: number) {
    return this.getRequest(`${ApiEndpoints.myHouseView}/${id}`);
  }

  createUserView(entity: any) {
    if (entity.id) {
      return this.putRequest(ApiEndpoints.myHouseView, entity);
    }
    return this.postRequest(ApiEndpoints.myHouseView, entity);
  }

  deleteUserView(entity: any) {
    return this.deleteRequest(ApiEndpoints.myHouseView, entity.id);
  }

  // Firm house views
  getFirmViews(companyId?: number) {
    const params = companyId ? { company_id: companyId } : {};
    return this.getRequest(ApiEndpoints.firmHouseViews, params);
  }

  getFirmView(id: number) {
    return this.getRequest(`${ApiEndpoints.firmHouseView}/${id}`);
  }

  createFirmView(entity: any, companyId?: number) {
    if (entity.id) {
      return this.putRequest(ApiEndpoints.firmHouseView, entity);
    }
    const payload = companyId ? { ...entity, company_id: companyId } : entity;
    return this.postRequest(ApiEndpoints.firmHouseView, payload);
  }

  deleteFirmView(entity: any) {
    return this.deleteRequest(ApiEndpoints.firmHouseView, entity.id);
  }
}
